import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import Logo from "./Logo";
import { NAV, CALENDLY } from "../data/site";

export default function Navigation() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <>
      <motion.header
        initial={{ y: -40, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 1, ease: [0.16, 1, 0.3, 1], delay: 0.2 }}
        className="fixed top-0 left-0 z-50 w-full"
        data-testid="main-nav"
      >
        <div
          className={`absolute inset-0 transition-[background-color,backdrop-filter] duration-700 ${
            scrolled
              ? "bg-black/50 backdrop-blur-xl border-b border-white/[0.06]"
              : "bg-transparent"
          }`}
        />
        <nav className="relative flex items-center justify-between px-6 md:px-12 lg:px-16 py-5">
          <a href="#top" data-testid="nav-logo" className="relative z-10">
            <Logo size="text-xl md:text-2xl" />
          </a>

          <div className="hidden md:flex items-center gap-9">
            {NAV.map((n) => (
              <a
                key={n.label}
                href={n.href}
                data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
                className="label text-white/60 hover:text-lav-400 transition-colors duration-300"
              >
                {n.label}
              </a>
            ))}
            <a
              href={CALENDLY}
              target="_blank"
              rel="noreferrer"
              data-cursor="OPEN"
              data-testid="nav-cta"
              className="label group relative inline-flex items-center overflow-hidden border border-white/20 px-5 py-2.5 text-white"
            >
              <span className="relative z-10 transition-colors duration-300 group-hover:text-black">
                LET'S TALK ↗
              </span>
              <span className="absolute inset-0 z-0 -translate-y-full bg-lav-400 transition-transform duration-500 ease-lux group-hover:translate-y-0" />
            </a>
          </div>

          <button
            className="md:hidden relative z-10 label text-white"
            onClick={() => setOpen((o) => !o)}
            data-testid="nav-menu-toggle"
          >
            {open ? "CLOSE" : "MENU"}
          </button>
        </nav>
      </motion.header>

      {/* Mobile overlay */}
      <motion.div
        initial={false}
        animate={{ clipPath: open ? "inset(0% 0% 0% 0%)" : "inset(0% 0% 100% 0%)" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="fixed inset-0 z-40 bg-black md:hidden flex flex-col justify-center px-8 gap-2"
        data-testid="mobile-menu"
      >
        {NAV.map((n, i) => (
          <a
            key={n.label}
            href={n.href}
            onClick={() => setOpen(false)}
            className="text-huge text-white hover:text-lav-400 transition-colors"
            style={{ opacity: open ? 1 : 0, transition: `opacity .5s ${0.1 + i * 0.05}s` }}
          >
            {n.label}
          </a>
        ))}
        <a
          href={CALENDLY}
          target="_blank"
          rel="noreferrer"
          className="mt-8 label text-lav-400"
          onClick={() => setOpen(false)}
        >
          LET'S TALK ↗
        </a>
      </motion.div>
    </>
  );
}
